import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Segment layout: carries the "Organizations" breadcrumb for the list and every detail page. */
export const Route = createFileRoute('/_authed/organizations')({
  staticData: { crumbKey: 'nav.organizations' },
  component: Outlet,
});
